import {containsQueryParameter, getSessionProperty, removeSessionProperty, setSessionProperty} from './sessionProperties'
import {getCourseCode} from "./course";

export const APPLICATION_ID_SESSION_STORAGE_KEY = 'APPLICATION_ID'
export const APPLICATION_ID_QUERY_PARAMETER = 'applicationid'

export const APPLICATION_LINE_ID_SESSION_STORAGE_KEY = 'APPLICATION_LINE_ID'
export const APPLICATION_LINE_ID_QUERY_PARAMETER = 'applicationlineid'

export const OFFERS_ID_SESSION_STORAGE_KEY = 'OFFERS_ID'

export const removeOfferSessionStorageItemsIfQueryParameterFound = (searchLocation, queryParameter) => {
  if (containsQueryParameter(searchLocation, queryParameter, true)) {
    removeAllOfferSessionProperties();
  }
}

export const removeAllOfferSessionProperties = () => {
  removeSessionProperty(APPLICATION_ID_SESSION_STORAGE_KEY);
  removeSessionProperty(APPLICATION_LINE_ID_SESSION_STORAGE_KEY);
  removeSessionProperty(OFFERS_ID_SESSION_STORAGE_KEY);
}

export const getOfferApplicationLineId = searchLocation => {
  removeOfferSessionStorageItemsIfQueryParameterFound(searchLocation, APPLICATION_LINE_ID_QUERY_PARAMETER)
  return getSessionProperty(
    APPLICATION_LINE_ID_SESSION_STORAGE_KEY,
    APPLICATION_LINE_ID_QUERY_PARAMETER,
    searchLocation
  )
}

export const setOfferApplicationLineId = searchLocation => {
  removeOfferSessionStorageItemsIfQueryParameterFound(searchLocation, APPLICATION_LINE_ID_QUERY_PARAMETER)
  return setSessionProperty(
    APPLICATION_LINE_ID_SESSION_STORAGE_KEY,
    APPLICATION_LINE_ID_QUERY_PARAMETER,
    searchLocation
  )
}

export const getOfferApplicationId = searchLocation => {
  removeOfferSessionStorageItemsIfQueryParameterFound(searchLocation, APPLICATION_ID_QUERY_PARAMETER)
  return getSessionProperty(
    APPLICATION_ID_SESSION_STORAGE_KEY,
    APPLICATION_ID_QUERY_PARAMETER,
    searchLocation
  )
}

export const setOfferApplicationId = searchLocation => {
  removeOfferSessionStorageItemsIfQueryParameterFound(searchLocation, APPLICATION_ID_QUERY_PARAMETER)
  return setSessionProperty(
    APPLICATION_ID_SESSION_STORAGE_KEY,
    APPLICATION_ID_QUERY_PARAMETER,
    searchLocation
  )
}

export const getOffersId = () => {
  return getSessionProperty(OFFERS_ID_SESSION_STORAGE_KEY)
}

export const setOffersId = (
  offerApplicationId,
  offerApplicationLineId,
  courseCode
) => {
  if (offerApplicationId) {
    setSessionProperty(OFFERS_ID_SESSION_STORAGE_KEY, null, offerApplicationId)
  } else if (offerApplicationLineId) {
    setSessionProperty(
      OFFERS_ID_SESSION_STORAGE_KEY,
      null,
      offerApplicationLineId
    )
  } else if (courseCode) {
    setSessionProperty(OFFERS_ID_SESSION_STORAGE_KEY, null, courseCode)
  }
}

export const containsOffers = (offers = getOffersStaticInfoCache()) => {
  return offers !== null && offers !== undefined && offers.length > 0
}

export const offersStaticInfoCache = offers => {
  const cacheName = `OFFERS_STATIC_INFO_${getOffersId()}`

  sessionStorage.setItem(cacheName, JSON.stringify(offers))
}

export const getOffersStaticInfoCache = () => {
  const cacheName = `OFFERS_STATIC_INFO_${getOffersId()}`

  let offers = sessionStorage.getItem(cacheName)

  return offers ? JSON.parse(offers) : null
}

export const offerStaticInfoCache = (offer, offerApplicationId) => {
  const cacheName = `OFFER_STATIC_INFO_${offerApplicationId}`

  sessionStorage.setItem(cacheName, JSON.stringify(offer))
}

export const getOfferStaticInfoCache = () => {
  let offerApplicationId = getOfferApplicationId()
  if (!offerApplicationId) {
    offerApplicationId = getCourseCode()
  }
  const cacheName = `OFFER_STATIC_INFO_${offerApplicationId}`

  let offer = sessionStorage.getItem(cacheName)

  return offer ? JSON.parse(offer) : null
}

export const getAttributeFromOfferStaticInfo = attributeName => {
  const offerApplicationId = getOfferApplicationId()
  const cacheName = `OFFER_STATIC_INFO_${offerApplicationId}`

  const offerStaticInfoFromCache = sessionStorage.getItem(cacheName)

  if (offerStaticInfoFromCache != null) {
    const attributeValue = JSON.parse(offerStaticInfoFromCache)[attributeName]
    return attributeValue
  } else {
    return null
  }
}
